import { isFunction } from 'helpers/data'
import { FC } from 'react'
import { ComboboxProps } from './combobox'
import { Highlighted } from './highlighted'
import { ComboboxOption, isOptionGuard } from './types'

const isDefaultOption = (option) => {
  return option.id === null
}

type OptionProps = Pick<ComboboxProps, 'OptionComponent'> & {
  selected: boolean
  option: ComboboxOption
  active: boolean
}
export const Option: FC<OptionProps> = ({
  selected,
  OptionComponent,
  option,
  active,
}) => {
  const isCustomizableItem = Boolean(
    isFunction(OptionComponent) && !isDefaultOption(option),
  )

  const itemContents = () => {
    // custom
    if (isCustomizableItem) {
      return OptionComponent({
        id: option.id,
        active,
        selected,
        highlights: option.highlights,
      })
    }

    // decorated search highlights
    if (isOptionGuard(option) && option.highlights) {
      return <Highlighted highlights={option.highlights} />
    }

    return option.value
  }
  return (
    <span
      aria-label={option.value}
      className={`${selected ? 'font-bold' : 'font-normal'} block truncate`}>
      {itemContents()}
    </span>
  )
}
